var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-2 lg:grid-cols-4 gap-4 gap-y-8 lg:gap-8 mb-8"},_vm._l((_vm.products),function(csProduct,index){return _c('div',{key:index},[_c('ProductCard',{attrs:{"product":csProduct,"position":index,"list":"You may also like"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }